export default {
  errorMessage: {
    startAtUtc: 'Czas rozpoczęcia nie może być późniejszy niż czas zakończenia.',
    endAtUtc: 'Czas zakończenia nie może być wcześniejszy niż czas rozpoczęcia',
  },
};
